<template>
  <div>
    <van-popup
      v-model="show"
      class="full-width"
      :close-on-popstate="true"
      closeable
      close-icon="close"
      position="bottom"
      round
    >
      <ld-header @click-left="show = false">
        <span slot="left" />
        选择{{ title }}
      </ld-header>
      <van-cell-group>
        <van-cell
          v-for="(address, index) in addressList"
          :key="index"
          :label="`${address.recipient}   ${address.phoneNumber}`"
          clickable
          @click="select(address)"
        >
          <span
            class="font16 font-bold"
            slot="title"
          >
            {{ address.cName }}  {{ address.cityName }} {{ address.addr }}
          </span>
        </van-cell>
      </van-cell-group>
      <ld-no-more
        v-if="addressList.length === 0"
        text="请前往添加常用地址~"
      />
      <div style="padding: 10px 30px;">
        <ld-button
          @click="add"
          size="lg"
          main3
        >
          添加地址
        </ld-button>
      </div>
    </van-popup>

    <van-popup
      v-model="addShow"
      :lock-scroll="true"
      position="right"
      class="full-height full-width"
      :close-on-click-overlay="false"
    >
      <ld-header
        :z-index="2"
        @click-left="addShow = false"
      />
      <EditAddress
        class="hide-top"
        @submit="addSuccess"
      />
    </van-popup>
  </div>
</template>

<script>
import { Search, Popup, Cell, CellGroup } from 'vant'
import ldButton from 'Common/ldButton'
import ldNoMore from 'Common/ldNoMore'
import EditAddress from 'Views/Home/userCenter/CommonInfo/EditAddress'

import AddressInteractor from 'Domain/use-cases/address-interactor'

export default {
  name: 'LdAddress',
  components: {
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    ldButton, ldNoMore, EditAddress
  },
  props: {
    title: {
      type: [String],
      default: '收件地址'
    }
  },
  data() {
    return {
      show: false,
      addShow: false,
      addressList: []
    }
  },
  created() {
    this.getAddressList()
  },
  methods: {
    select (address) {
      this.show = false
      this.$emit('selected', address)
    },
    toggle() {
      this.show = !this.show
    },
    /**
     * 新增常用地址
     */
    add () {
      this.addShow = true
    },
    addSuccess () {
      this.show = false
      this.addShow = false
      this.getAddressList()
    },
    /**
     * 获取常用地址列表
     */
    async getAddressList () {
      const { data } = await AddressInteractor.getAddressList()
      this.addressList = data
      
      let Default_Addr = this.addressList.find(addr => addr.isDefault)
      if (Default_Addr) this.$emit('selected', Default_Addr)
    },
  }
}
</script>

<style lang="less" scoped>
.hide-top {
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
